var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1919_24274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0544 27.1957H29.7016C29.8234 27.1957 29.9299 27.1502 30.0212 27.044C30.1125 26.9529 30.1733 26.8467 30.1733 26.7254V22.7506H13.0544V27.1957ZM5.82646 13.4356H10.7719V8.99049H6.29819C6.17645 8.99049 6.06993 9.036 5.97863 9.1422C5.88733 9.23323 5.82646 9.33942 5.82646 9.46079V13.4356ZM5.82646 20.5356H10.7719V15.7112H5.82646V20.5356ZM6.29819 27.2108H10.7719V22.7657H5.82646V26.7405C5.82646 26.8619 5.87212 26.9681 5.97863 27.0591C6.06993 27.1502 6.17645 27.2108 6.29819 27.2108ZM13.0544 20.5356H30.1733V15.7112H13.0544V20.5356ZM13.0544 13.4356H30.1733V9.46079C30.1733 9.33942 30.1277 9.23323 30.0212 9.1422C29.9299 9.05118 29.8234 8.99049 29.7016 8.99049H13.0544V13.4356ZM6.29819 29.4713C5.52213 29.4713 4.88302 29.1982 4.35044 28.6673C3.80263 28.1363 3.54395 27.4991 3.54395 26.7254V9.46079C3.54395 8.68707 3.80263 8.04989 4.35044 7.51891C4.88302 6.98792 5.53735 6.71484 6.29819 6.71484H29.7016C30.4777 6.71484 31.1168 6.98792 31.6494 7.51891C32.182 8.04989 32.4559 8.70224 32.4559 9.46079V26.7254C32.4559 27.4991 32.182 28.1363 31.6494 28.6673C31.1168 29.1982 30.4625 29.4713 29.7016 29.4713H6.29819Z",
    fill: "#01A0A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1919_24274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.9119,
    height: 22.7565,
    fill: "white",
    transform: "translate(3.54395 6.71484)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunction);
export default __webpack_public_path__ + "static/media/function.4649936f905bdee9332f33e04f0aec18.svg";
export { ForwardRef as ReactComponent };